/**
 * BackgroundTimer Web implementation
 * Provides browser-compatible timer functionality for React Native Web
 */

const BackgroundTimer = {
  setTimeout(callback, delay) {
    return setTimeout(callback, delay);
  },
  
  setInterval(callback, delay) {
    return setInterval(callback, delay);
  },
  
  clearTimeout(timeoutId) {
    return clearTimeout(timeoutId);
  },
  
  clearInterval(intervalId) {
    return clearInterval(intervalId);
  },
  
  start(delay = 0) {
    if (delay > 0) {
      return setTimeout(() => {
        console.log('Background timer started');
      }, delay);
    }
  },
  
  stop() {
    console.log('Background timer stopped');
  }
};

export default BackgroundTimer;